module.exports = {

    data(){
        return {
            permissions: []
        }
    },

    methods: {

        /**
         * Fetch all permissions
         */
        fetchPermissions(){
            axios.get('/management/permissions').then(response => {
               this.permissions = response.data
            })
        },
    }
}

